import { render, staticRenderFns } from "./FormSalas.vue?vue&type=template&id=1a8c7062"
import script from "./FormSalas.vue?vue&type=script&lang=js"
export * from "./FormSalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports